/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React, {
  forwardRef,
  memo,
  useImperativeHandle
} from 'react';
import {GenericObject} from '@ion/core/src/types/entities';
import EmbeddedForm from '@ion/dls/src/editors/forms/EmbeddedForm';
import {useEditorStyles} from '@ion/dls/src/hooks/useEditorStyles';
import {BodyTypography} from '@ion/dls/src/typography/BodyTypography';

interface MessageFormProps {
  message: string;
  onSave: (details: GenericObject) => void;
}

/**
 * Re-usable bulk operation form for actions that don't require action details.
 *
 * Displays a custom message and returns no details.
*/
export const MessageForm = forwardRef(({
  message,
  onSave
}: MessageFormProps, ref) => {
  const {classes} = useEditorStyles();

  const onSubmit = () => {
    onSave({});
  };

  useImperativeHandle(ref, () => ({
    onSubmit
  }), [onSubmit]);

  return (
    <EmbeddedForm>
      <div className={classes.centered}>
        <BodyTypography variant={'body2'} align={'center'}>
          {message}
        </BodyTypography>
      </div>
    </EmbeddedForm>
  );
});

export default memo(MessageForm);
